import { WebPlugin } from '@capacitor/core';
export class FileOpenerWeb extends WebPlugin {
    async openFile(options) {
        if (!options.blob) {
            throw new Error(FileOpenerWeb.ERROR_BLOB_MISSING);
        }
        const objectUrl = URL.createObjectURL(options.blob);
        window.open(objectUrl, '_blank');
    }
}
FileOpenerWeb.ERROR_BLOB_MISSING = 'blob must be provided.';
//# sourceMappingURL=web.js.map